// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8f3e3e4f","212":"c03a680d","882":"c9ef8dfd","912":"c5cb9cc5","935":"63174672"}[chunkId] + ".chunk.css";
};